//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CloudDM.js";
import "../no/Object.js";
import "../no/PartSaveStatus.js";
import "../CloudDM/CloudDM.DataManager.js";
let d=[[],[[["inputPart"],"GetDocumentIdentifier",{R_:{document:"CloudDM.DocumentIdentifier"}},1,0],[["inputPart","newFileName","newDesignInfo"],"SaveAs",{R_:{saveStatus:"PartSaveStatus"}},3,0],[["partsToCheckOut"],"CheckoutParts",{},1,0],[["partsToCheckIn"],"CheckinParts",{},1,0],[["partsToFreeze"],"FreezeParts",{},1,0],[["inputPart","nDrawings"],"GetRelatedDrawings",{R_:{drawings:"CloudDM.DocumentIdentifier[]"}},1,0],[["inputPart","attachmentInfos","nDocuments"],"GetAttachedDocuments",{R_:{documents:"CloudDM.DocumentIdentifier[]"}},2,0]],[]];
SPLM.CloudDM.PartUtils = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CloudDM.PartUtils";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CloudDM.PartUtils.AttachmentInfo = class{
    constructor(attachmentType,typeName){
        this.attachmentType=attachmentType;this.typeName=typeName;}
    get Attachmenttype(){return this.attachmentType}
    set Attachmenttype(val){this.attachmentType = val}
    get Typename(){return this.typeName}
    set Typename(val){this.typeName = val}
};

export default SPLM;